// 封装操作localstorage本地存储的方法  模块化

const storage = {
    /**
     * 设置本地存储
     * @param {string} key - 存储的键
     * @param {any} value - 存储的值
     */
    set(key, value) {
        try {
            const data = { data: value };
            localStorage.setItem(key, JSON.stringify(data));
        } catch (error) {
            console.error(`Error setting item in localStorage: ${error}`);
        }
    },

    /**
     * 获取本地存储的值
     * @param {string} key - 存储的键
     * @returns {any|null} - 返回存储的值或 null
     */
    get(key) {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item).data : null;
        } catch (error) {
            console.error(`Error getting item from localStorage: ${error}`);
            return null;
        }
    },

    /**
     * 根据索引获取本地存储的键
     * @param {number} index - 索引
     * @returns {string|null} - 返回存储的键或 null
     */
    getForIndex(index) {
        return localStorage.key(index);
    },

    /**
     * 获取所有的键
     * @returns {Array<string>} - 返回所有存储的键
     */
    getKeys() {
        return Array.from({ length: localStorage.length }, (_, i) => localStorage.key(i)).filter(Boolean);
    },

    /**
     * 获取本地存储的长度
     * @returns {number} - 返回存储的键值对数量
     */
    getLength() {
        return localStorage.length;
    },

    /**
     * 检查浏览器是否支持 localStorage
     * @returns {boolean} - 返回支持状态
     */
    getSupport() {
        return typeof Storage !== "undefined";
    },

    /**
     * 移除指定的键
     * @param {string} key - 存储的键
     */
    remove(key) {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing item from localStorage: ${error}`);
        }
    },

    /**
     * 清除所有本地存储
     */
    removeAll() {
        try {
            localStorage.clear();
        } catch (error) {
            console.error(`Error clearing localStorage: ${error}`);
        }
    },

    /**
     * 获取所有的键值对
     * @returns {Array<{key: string, val: any}>} - 返回所有存储的键值对
     */
    getAll() {
        return Array.from({ length: localStorage.length }, (_, i) => {
            const key = localStorage.key(i);
            const val = this.get(key);
            return { key, val };
        }).filter(item => item.key !== null); // 过滤掉空键
    }
};

export default storage;